import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const CollaborationBar = ({ collaborators, comments, onToggleComments }) => {
  return (
    <div className="bg-card border-b border-border px-4 py-2 flex items-center justify-between">
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
          <Icon name="Users" size={16} className="text-muted-foreground" />
          <span className="text-xs md:text-sm text-muted-foreground">
            {collaborators?.length} collaborator{collaborators?.length !== 1 ? 's' : ''} online
          </span>
        </div>
        <div className="flex -space-x-2">
          {collaborators?.map((collaborator) => (
            <div
              key={collaborator?.id}
              className="relative"
              title={collaborator?.name}
            >
              <Image
                src={collaborator?.avatar}
                alt={collaborator?.avatarAlt}
                className="w-7 h-7 md:w-8 md:h-8 rounded-full border-2 border-card object-cover"
              />
              <div
                className={`absolute bottom-0 right-0 w-2 h-2 rounded-full border border-card ${
                  collaborator?.isActive ? 'bg-success' : 'bg-muted-foreground'
                }`}
              />
            </div>
          ))}
        </div>
      </div>
      <button
        onClick={onToggleComments}
        className="flex items-center gap-2 px-3 py-1.5 rounded-lg hover:bg-muted transition-colors"
      >
        <Icon name="MessageSquare" size={16} className="text-muted-foreground" />
        <span className="text-xs md:text-sm text-foreground font-medium">{comments}</span>
      </button>
    </div>
  );
};

export default CollaborationBar;